// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: 'http://103.248.209.130:8000/cas/v1/',
  apiEndpointRdbms: 'http://103.248.209.130:8000/cas/v1/',

  imageUploadEndpoint: 'http://103.248.209.130:2210/uploadfs',
  imageHttpsUrlPrefix: 'https://103.248.209.130:8000/iptvconsole/',
  imageUrlPrefix: 'https://103.248.209.130/',

  defaultPageSize: 10,
  defaultPageNumber: 1,
  defaultSortBy: 'createdDate',
  defaultSortOrder: 'DESC',
  defaultPageSizeOptions: [5, 10, 20, 50, 100]
};

